import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import ShuruDashboard from './ShuruDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyShuruDashboard } from './companyShuruApi';

/** Company Shuru → Dashboard, scoped to this company. */
const CShuruDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyShuruDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shuru | Shoorah</title>
      </Helmet>
      <ShuruDashboard fetcher={fetcher} populationLabel={isB2BFansMode ? 'members' : 'employees'} />
    </div>
  );
};

export default CShuruDashboard;
